<script setup>
import { computed } from 'vue';
import theme from '@/ui/Badge/index.js';
import CFIcon from '@/ui/Icon/CFIcon.vue';

const props = defineProps({
    label: {
        type: String,
        default: undefined,
    },
    color: {
        type: String,
        default: 'primary',
        validator: (v) => ['primary', 'success', 'warning', 'danger', 'info', 'neutral', 'gradient'].includes(v),
    },
    variant: {
        type: String,
        default: 'solid',
        validator: (v) => ['solid', 'outline'].includes(v),
    },
    size: {
        type: String,
        default: 'md',
        validator: (v) => ['xs', 'sm', 'md', 'lg'].includes(v),
    },
    icon: {
        /** @type import('vue').PropType<IconName> */
        type: String,
        default: undefined,
    },
});

const ui = computed(() =>
    theme({
        color: props.color,
        variant: props.variant,
        size: props.size,
    })
);
</script>

<template>
    <span :class="ui.base({ class: props.ui?.base })">
        <slot name="leading">
            <CFIcon
                v-if="icon"
                :name="icon"
                :class="ui.icon({ class: props.ui?.icon })"
            />
        </slot>

        <slot>
            <span
                v-if="label"
                :class="ui.label({ class: props.ui?.label })"
            >
                {{ label }}
            </span>
        </slot>
    </span>
</template>
